// Abbreviate large numbers with intelligent rounding & unit promotion.
// 49940 -> 49.9K, 120000 -> 120K, 999999 -> 1M, 1250000 -> 1.25M
export function abbrevNum(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const num = Number(n);
  const abs = Math.abs(num);
  if (abs < 1000) return num.toLocaleString();
  const units = [["T", 1e12], ["B", 1e9], ["M", 1e6], ["K", 1e3]];
  const fmt = (value, val) => {
    const scaled = value / val;
    const a = Math.abs(scaled);
    const decimals = a >= 100 ? 0 : a >= 10 ? 1 : 2;
    return parseFloat(scaled.toFixed(decimals));
  };
  for (let i = 0; i < units.length; i++) {
    const [suffix, val] = units[i];
    if (abs >= val) {
      const rounded = fmt(num, val);
      // Promote to the next larger unit if rounding pushed us to 1000
      // (e.g. 999999 -> "1000K" should become "1M").
      if (Math.abs(rounded) >= 1000 && i > 0) {
        const [pSuffix, pVal] = units[i - 1];
        return `${fmt(num, pVal)}${pSuffix}`;
      }
      return `${rounded}${suffix}`;
    }
  }
  return num.toLocaleString();
}

// Pick a responsive font-size class based on rendered string length so
// large numbers never clip inside their card.
export function fitTextSize(str) {
  const len = String(str).length;
  if (len >= 8) return "text-xl sm:text-2xl";
  if (len >= 6) return "text-2xl sm:text-3xl";
  return "text-3xl sm:text-4xl";
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}
